import {
  ImageScaleView,
  ImageScaleViewOpts,
  View,
  ViewOpts,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export class RacesScore extends View {
  private readonly score: LangBitmapFontTextView;
  private readonly scoreBg: ImageScaleView;
  private readonly scoreIcon: ImageScaleView;

  constructor(opts: ViewOpts) {
    super({
      width: 80,
      height: 80,
      ...opts,
    });

    this.scoreBg = new ImageScaleView({
      superview: this,
      x: 55,
      y: this.style.height * 0.5 + 2,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      align: 'center',
      verticalAlign: 'center',
      width: 117,
      height: 42,
      image: 'assets/ui/match2/tournament/star_tournament_score_bg.png',
    });

    this.score = new LangBitmapFontTextView({
      superview: this,
      x: 15,
      y: 0,
      align: 'right',
      verticalAlign: 'center',
      size: 26,
      font: 'Title',
      width: 80,
      height: this.style.height,
    });

    this.scoreIcon = new ImageScaleView({
      superview: this,
      x: 0,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      align: 'center',
      verticalAlign: 'center',
      width: 44,
      height: 44,
    });
  }

  public setup(params: { score: number; icon: ImageScaleViewOpts }) {
    this.score.localeText = () => `${params.score}`;
    this.scoreIcon.updateOpts(params.icon);
  }
}
